var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkJump(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M790.536784 923.653571 77.292364 923.653571 77.292364 228.828662 625.784486 228.828662 625.784486 264.644379 113.108081 264.644379 113.108081 887.837854 753.697761 887.837854 753.697761 410.977165 790.536784 410.977165Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M904.925691 115.801844l25.885344 25.885344-400.116482 400.116482-25.885344-25.885344 400.116482-400.116482Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M932.909375 340.16233 896.369158 338.016457 908.096247 138.5311 708.61089 150.258189 706.465017 113.717971 947.06784 99.559507Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkJump);
export default __webpack_public_path__ + "static/media/linkJump.bf05a2c28c4de3c1091068fb5226bb85.svg";
export { ForwardRef as ReactComponent };